import { render, staticRenderFns } from "./grxx_detaill.vue?vue&type=template&id=0232ed75&"
import script from "./grxx_detaill.vue?vue&type=script&lang=js&"
export * from "./grxx_detaill.vue?vue&type=script&lang=js&"
import style0 from "./grxx_detaill.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports